// import { createContext, useContext, useEffect, useState } from "react";
// import socket from "./socket";
// import api from "./apiClient"; // your axios instance
// import { AuthContext } from "../authContext/AuthContext";
// const SocketContext = createContext(null);
// export const SocketProvider = ({ storeId, children }) => {
//   const { token } = useContext(AuthContext);
//   const [status, setStatus] = useState(
//     socket.connected ? "connected" : "connecting",
//   );
//   const refreshToken = async () => {
//     const res = await api.post("/auths/refresh");
//     localStorage.setItem("token", res.data.accessToken);
//     return res.data.accessToken;
//   };

//   useEffect(() => {
//     if (!token || !storeId) return;
//     socket.auth = { token };
//     socket.connect();
//     const onConnect = () => {
//       setStatus("connected");
//       socket.emit("join-store", storeId);
//     };

//     const onDisconnect = () => {
//       setStatus("disconnected");
//     };

//     socket.on("connect", onConnect);
//     socket.on("disconnect", onDisconnect);

//     let isRefreshing = false;
//     socket.on("connect_error", async (err) => {
//       if (err.message === "jwt expired" && !isRefreshing) {
//         isRefreshing = true;
//         try {
//           const newToken = await refreshToken();
//           socket.auth.token = newToken;
//           socket.connect();
//         } finally {
//           isRefreshing = false;
//         }
//       }
//     });

//     return () => {
//       socket.emit("leave-store", storeId);
//       socket.off("connect", onConnect);
//       socket.off("disconnect", onDisconnect);
//       socket.disconnect();
//     };
//   }, [storeId, token]);

//   return (
//     <SocketContext.Provider
//       value={{
//         socket,
//         isConnected: status === "connected",
//         status,
//       }}
//     >
//       {children}
//     </SocketContext.Provider>
//   );
// };

// export const useSocket = () => useContext(SocketContext);
import { createContext, useContext, useEffect, useRef, useState } from "react";
import socket from "./socket";
import api from "./apiClient";
import { AuthContext } from "../authContext/AuthContext";

const SocketContext = createContext(null);

export const SocketProvider = ({ storeId, children }) => {
  const { token, setToken, logout } = useContext(AuthContext);
  const [status, setStatus] = useState(
    socket.connected ? "connected" : "disconnected",
  );
  const isRefreshingRef = useRef(false);

  const refreshToken = async () => {
    const res = await api.post("/auths/refresh");
    const newAccessToken = res.data.accessToken;

    localStorage.setItem("token", newAccessToken);
    setToken?.(newAccessToken);

    return newAccessToken;
  };

  // Handle socket connection
  useEffect(() => {
    if (!token) return;

    const onConnect = () => {
      setStatus("connected");
    };

    const onDisconnect = async (reason) => {
      setStatus("disconnected");

      if (reason === "io server disconnect" && !isRefreshingRef.current) {
        isRefreshingRef.current = true;

        try {
          const newToken = await refreshToken();
          socket.auth = { token: newToken };
          socket.connect();
        } catch (err) {
          console.error("Socket reconnect after disconnect failed:", err);
          logout?.();
        } finally {
          isRefreshingRef.current = false;
        }
      }
    };

    const onConnectError = async (err) => {
      console.log("connect_error:", err.message);

      if (err.message === "jwt expired" && !isRefreshingRef.current) {
        isRefreshingRef.current = true;

        try {
          const newToken = await refreshToken();
          socket.auth = { token: newToken };
          socket.connect();
        } catch (error) {
          console.error("Socket reconnect after connect_error failed:", error);
          logout?.();
        } finally {
          isRefreshingRef.current = false;
        }
      }
    };

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("connect_error", onConnectError);

    socket.auth = { token };

    if (!socket.connected) {
      setStatus("connecting");
      socket.connect();
    }

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("connect_error", onConnectError);

      // Disconnect only when auth/socket provider is really unmounting
      socket.disconnect();
    };
  }, [token]);

  // Handle room join/leave separately
  useEffect(() => {
    if (!storeId || !socket.connected) return;

    socket.emit("join-store", storeId);

    return () => {
      socket.emit("leave-store", storeId);
    };
  }, [storeId, status]);

  return (
    <SocketContext.Provider
      value={{
        socket,
        isConnected: status === "connected",
        status,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
